import toast from 'react-hot-toast'

// Simple error message extraction
export function getErrorMessage(error: unknown): string {
    if (error instanceof Error) return error.message
    if (typeof error === 'string') return error
    return 'An unexpected error occurred'
}

// Simple toast wrapper
export const notify = {
    error: (error: unknown) => toast.error(getErrorMessage(error)),
    success: (message: string) => toast.success(message),
    loading: (message: string) => toast.loading(message),
}
